<template>
  <div class="mt-2">
    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbytimeOptions && !loading">
            <apexchart
              ref="reportuserbytime"
              type="area"
              height="350"
              :options="reportuserbytimeOptions"
              :series="reportuserbytimeSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import DashboardGraphLoading from '../DashboardGraphLoading'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import analyticApi from '@/api/analytic'
import { handleResponse } from '@/api/util'
export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  props: ['type', 'app', 'date', 'fbpost'],
  data() {
    return {
      loading: true,
      reportuserbytimeSeries: null,
      reportuserbytimeOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('Message')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  watch: {
    async app(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    },
    async date(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    }
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      var response = await this.fetchData()
      await this.$nextTick()

      var data = []
      var raw = response.data[0]
      for (let index = 0; index <= 23; index++) {
        const element = raw[`time_${index}`]
        data.push([moment(index, 'HH').format('YYYY-MM-DDTHH:00:00'), parseInt(element)])
      }

      this.reportuserbytimeSeries = [{ name: this.$t('Message'), data: data }]
      var max = 0
      if (data && data.length > 0) {
        max = data.reduce((acc, val) => {
          acc = acc === undefined || val[1] > acc ? val[1] : acc
          return acc
        }, [])
      }

      if (this.$refs.reportuserbytime) {
        this.$refs.reportuserbytime.updateOptions({
          yaxis: {
            max: max + 5
          }
        })
      }
      this.$emit('onLoaded', { loading: false, data: this.reportuserbytimeSeries })
      this.loading = false
    },
    async fetchData() {
      let config = {
        params: {
          pageid: this.selectedBot.pageid,
          app: this.app,
          from_date: moment(this.date.start).format('YYYY-MM-DD'),
          to_date: moment(this.date.end).format('YYYY-MM-DD')
        }
      }

      if (this.type == 'inbox') {
        config.params.page_intent = 'inbox'
        const response = await analyticApi.getReportActiveUsersByTime({ config })
        await handleResponse(response)
        if (response.data.responsecode == 200) {
          this.$emit('input', response.data.data)
          return response.data
        } else {
          throw new Error(response.data.responsecode + ': Something went wrong')
        }
      } else {
        if (this.fbpost) {
          config.params.post_id = this.fbpost.id
        }
        config.params.page_intent = 'comment'
        const response = await analyticApi.getReportActiveUsersByTime({ config })
        await handleResponse(response)
        if (response.data.responsecode == 200) {
          this.$emit('input', response.data.data)
          return response.data
        } else {
          throw new Error(response.data.responsecode + ': Something went wrong')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/report/ReportUserByTime.vue